export default function stringRedutor(string, stringLength) {
    if (!string) return 'título';
    if (string.length > stringLength - 1) {
        return string.substr(0, stringLength - 1).concat('...');
    }
    return string;
}